import PropTypes from "prop-types";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import localeFlag from "../commons/LocaleFlag";
import { ALFlags } from "../ALComponents";

function LocalePickerContent({ locale, handleClick }) {
  return (
    <div className="flex w-1/4 mobile:w-full mb-[34px] mobile:mb-[24px] flex-col mobile:flex-row mobile:items-center mobile:gap-[10px]">
      <button
        className="border-0 bg-transparent p-0 text-left cursor-pointer flex items-center text-black"
        onClick={() => handleClick(false, locale.countryName, locale.locale)}
        type="button"
      >
        {localeFlag[locale.country] && <ALFlags countryISO={locale.country} />}
        <p className="typo-body">{locale.countryName} | English</p>
      </button>
      <p className="typo-body text-dark-grey ml-[33px] mobile:ml-0">{locale.currency}</p>
    </div>
  );
}

LocalePickerContent.propTypes = {
  locale: PropTypes.shape({
    country: PropTypes.string,
    countryName: PropTypes.string,
    currency: PropTypes.string,
    locale: PropTypes.string,
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default withALErrorBoundary({
  name: "LocalePickerContent",
  priority: "P3",
})(LocalePickerContent);
